import config from '../config/environment';
import { withRequestIdHeaders } from '../utils/requestId';

export type CheckoutAvailabilityField = 'email' | 'cpf' | 'phone';

interface CheckoutAvailabilityResponse {
  success?: boolean;
  data?: {
    field?: CheckoutAvailabilityField;
    available?: boolean;
    message?: string | null;
  };
  error?: {
    message?: string;
  } | string;
  requestId?: string;
}

class CheckoutAvailabilityServiceClass {
  async checkField(
    field: CheckoutAvailabilityField,
    value: string,
    callingCode?: string,
    excludeStudentId?: number,
    options: { allowCheckoutContinuation?: boolean } = {},
  ): Promise<{ available: boolean; message: string | null }> {
    if (!config.supabaseFunctionsUrl) {
      throw new Error('URL das Edge Functions não configurada.');
    }

    const response = await fetch(`${config.supabaseFunctionsUrl}/students`, {
      method: 'POST',
      headers: withRequestIdHeaders({
        'Content-Type': 'application/json',
        apikey: config.supabaseAnonKey,
        Authorization: `Bearer ${config.supabaseAnonKey}`,
      }),
      body: JSON.stringify({
        action: 'check-availability',
        payload: {
          field,
          value,
          ...(callingCode ? { callingCode } : {}),
          ...(excludeStudentId ? { excludeStudentId } : {}),
          ...(options.allowCheckoutContinuation ? { allowCheckoutContinuation: true } : {}),
        },
      }),
    });

    const body = await response.json().catch(() => ({})) as CheckoutAvailabilityResponse;

    if (response.status === 429) {
      const message = typeof body.error === 'string'
        ? body.error
        : body.error?.message || 'Muitas tentativas. Aguarde alguns instantes e tente novamente.';
      throw new Error(message);
    }

    if (!response.ok || body.success === false) {
      const message = typeof body.error === 'string'
        ? body.error
        : body.error?.message || 'Não foi possível validar os dados informados.';
      throw new Error(message);
    }

    return {
      available: body.data?.available !== false,
      message: body.data?.message ?? null,
    };
  }
}

export const CheckoutAvailabilityService = new CheckoutAvailabilityServiceClass();
